/**
 * Bootstrap action creators — dispatched by Apollo/REST `onCompleted` handlers
 * to hydrate Redux from the bootstrap endpoint response.
 *
 * Previously named `apolloGraphql.js`; renamed to `bootstrapActions` because the
 * data now arrives via a REST bootstrap call, not GraphQL.
 *
 * Action-type strings are intentionally stable; existing reducers that switch on
 * them continue to work. The `[BOOTSTRAP]` prefix replaces the old `[APOLLO_GRAPHQL]`.
 *
 * The shim at `src/stash/actions/bootstrap.ts` re-exports everything here for
 * consumers that import from the `stash/actions` namespace. Deleted in C3 once
 * every consumer imports directly from `stash/store/bootstrapActions`.
 */

export const BOOTSTRAP = '[BOOTSTRAP]';

export const BOOTSTRAP_GET_USER_SUCCESS = `${BOOTSTRAP} GET USER SUCCESS`;
export const addUserToRedux = (user: unknown) => ({
	type: BOOTSTRAP_GET_USER_SUCCESS,
	response: { user },
});

export const BOOTSTRAP_GET_PROFILE_SUCCESS = `${BOOTSTRAP} GET PROFILE SUCCESS`;
export const addProfileToRedux = (profile: unknown) => ({
	type: BOOTSTRAP_GET_PROFILE_SUCCESS,
	response: { profile },
});

export const BOOTSTRAP_GET_ACCOUNTS_SUCCESS = `${BOOTSTRAP} GET ACCOUNTS SUCCESS`;
export const addAccountsToRedux = (accounts: unknown) => ({
	type: BOOTSTRAP_GET_ACCOUNTS_SUCCESS,
	response: { accounts },
});

export const BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS = `${BOOTSTRAP} GET FUNDING SOURCES`;
export const addFundingSourcesRedux = (funding_sources: unknown) => ({
	type: BOOTSTRAP_GET_FUNDING_SOURCES_SUCCESS,
	response: { funding_sources },
});

export const BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS = `${BOOTSTRAP} GET INVESTOR APPLICATION SUCCESS`;
export const addInvestorApplicationToRedux = (investor_application: unknown) => ({
	type: BOOTSTRAP_GET_INVESTOR_APPLICATION_SUCCESS,
	response: { investor_application },
});

export const BOOTSTRAP_GET_TRUSTED_CONTACT_SUCCESS = `${BOOTSTRAP} GET TRUSTED CONTACT SUCCESS`;
export const addTrustedContactToRedux = (trusted_contact: unknown) => ({
	type: BOOTSTRAP_GET_TRUSTED_CONTACT_SUCCESS,
	response: { trusted_contact },
});

export const BOOTSTRAP_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS = `${BOOTSTRAP} GET ELIGIBLE ACCOUNT TYPES SUCCESS`;
export const addEligibleAccountTypesToRedux = (eligible_account_types: unknown) => ({
	type: BOOTSTRAP_GET_ELIGIBLE_ACCOUNT_TYPES_SUCCESS,
	response: { eligible_account_types },
});

export const BOOTSTRAP_GET_ONBOARDING_QUESTIONS_SUCCESS = `${BOOTSTRAP} GET ONBOARDING QUESTIONS SUCCESS`;
export const addOnboardingQuestionsToRedux = (onboarding_questions: unknown) => ({
	type: BOOTSTRAP_GET_ONBOARDING_QUESTIONS_SUCCESS,
	response: { response: onboarding_questions },
});

export const BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS = `${BOOTSTRAP} GET ONBOARDING QUESTIONS ANSWERS SUCCESS`;
export const addOnboardingQuestionsAnswersToRedux = (onboarding_questions_answers: {
	questions: {
		financial_profile_question_1: unknown;
		financial_profile_question_2: unknown;
		financial_profile_question_3: unknown;
		financial_profile_question_4: unknown;
		[key: string]: unknown;
	};
	[key: string]: unknown;
}) => {
	const {
		financial_profile_question_1,
		financial_profile_question_2,
		financial_profile_question_3,
		financial_profile_question_4,
		...restQuestionsAnswers
	} = onboarding_questions_answers.questions;

	return {
		type: BOOTSTRAP_GET_ONBOARDING_QUESTIONS_ANSWERS_SUCCESS,
		response: {
			...onboarding_questions_answers,
			questions: {
				...restQuestionsAnswers,
				'financial-profile-question-1': financial_profile_question_1,
				'financial-profile-question-2': financial_profile_question_2,
				'financial-profile-question-3': financial_profile_question_3,
				'financial-profile-question-4': financial_profile_question_4,
			},
		},
	};
};

export const BOOTSTRAP_GET_CART_ITEMS_SUCCESS = `${BOOTSTRAP} GET CART ITEMS SUCCESS`;
export const addCartItemsToRedux = (cart_items_with_cards: unknown) => ({
	type: BOOTSTRAP_GET_CART_ITEMS_SUCCESS,
	response: { cart_items_with_cards },
});
